const AUTH_TOKEN_KEY = "token";
const AUTH_COOKIE_NAME = "tasksuite_auth_token";
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

const isTasksuiteHost = (hostname) =>
  hostname === "tasksuite.co" || hostname === "www.tasksuite.co";

const buildCookieAttributes = (expiresAt) => {
  const parts = [
    `Path=/`,
    `Expires=${new Date(expiresAt).toUTCString()}`,
    `SameSite=Lax`,
  ];

  if (typeof window !== "undefined" && isTasksuiteHost(window.location.hostname)) {
    parts.push("Domain=.tasksuite.co");
  }

  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    parts.push("Secure");
  }

  return parts.join("; ");
};

export const getTokenFromCookie = () => {
  if (typeof document === "undefined") return "";

  const prefix = `${AUTH_COOKIE_NAME}=`;
  const match = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(prefix));

  if (!match) return "";

  try {
    return decodeURIComponent(match.slice(prefix.length));
  } catch {
    return match.slice(prefix.length);
  }
};

export const getStoredAuthToken = () => {
  if (typeof window === "undefined") return "";

  const localToken = window.localStorage.getItem(AUTH_TOKEN_KEY);
  if (localToken) return localToken;

  const cookieToken = getTokenFromCookie();
  if (cookieToken) {
    window.localStorage.setItem(AUTH_TOKEN_KEY, cookieToken);
  }
  return cookieToken;
};

export const persistAuthToken = (token) => {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const normalized = String(token || "").trim();
  if (!normalized) return;

  window.localStorage.setItem(AUTH_TOKEN_KEY, normalized);
  document.cookie = `${AUTH_COOKIE_NAME}=${encodeURIComponent(normalized)}; ${buildCookieAttributes(Date.now() + THIRTY_DAYS_MS)}`;
};

export const clearStoredAuthToken = () => {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
  }

  if (typeof document !== "undefined") {
    document.cookie = `${AUTH_COOKIE_NAME}=; ${buildCookieAttributes(0)}`;
  }
};
